import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import IMAGES from "../../../constant/IMAGES";
import HeroBubble from "../../HeroBubble";
import TextHeader from "../../TextHeader";

const items = [
  {
    title: "Số lượt tải",
    number: "20000",
    icon: IMAGES.download,
  },
  {
    title: "Số tính năng",
    number: "14",
    icon: IMAGES.features,
  },
  {
    title: "Số lượt đặt lịch",
    number: "70000",
    icon: IMAGES.calendar,
  },
  {
    title: "Số lượt truy cập",
    number: "90000",
    icon: IMAGES.access,
  },
];

const SectionNumber = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  // } flex gap-3 xl:gap-[35px] items-center bg-[#1E1E1C] xl:py-[30px] py-3 px-[10px] xl:px-[25px] rounded-[4px] xl:rounded-[10px] `}

  return (
    <div className="flex flex-col gap-8 xl:gap-36" ref={sectionRef}>
      <TextHeader text="CON SỐ ẤN TƯỢNG" />
      <div className="relative flex xl:flex-row flex-col-reverse items-center justify-center gap-4">
        <span className="bg-[#474031] size-[300px] rounded-full absolute bottom-0 blur-[110px] left-[22%] top-1/2 -translate-y-1/2 -translate-x-1/2"></span>

        <div className="grid grid-cols-1 gap-4 xl:gap-8 w-fit relative z-[2] sm:translate-y-[-85%] xl:translate-y-0 translate-y-[-60%]">
          <div className="flex gap-4 xl:gap-10 -translate-x-4">
            {items.slice(0, 2).map((i, index) => (
              <div
                key={index}
                className={`min-w-[120px] flex gap-3 xl:gap-5 bg-[#1E1E1C] group hover:bg-[#F0D35A4D] transition-all duration-300 xl:py-[30px] py-3 px-[10px] xl:px-[25px] rounded-[4px] xl:rounded-[10px] `}
              >
                <img
                  src={i.icon}
                  alt={i.title}
                  className="sm:size-[60px] size-8 xl:size-[90%] aspect-square"
                />
                <div className="flex flex-col gap-1">
                  <p className="text-[#F0D35A99] text-[10px] font-habibi group-hover:text-white xl:text-2xl whitespace-nowrap">
                    {i.title}
                  </p>
                  <p className="text-[#F0D35A] font-bold group-hover:text-white text-[13px] xl:text-[32px]">
                    {isVisible && (
                      <CountUp
                        end={Number(i.number)}
                        duration={3}
                        formattingFn={(value) => {
                          const targetLength = i.number.replace(
                            /[,.]/g,
                            ""
                          ).length;
                          const formattedValue = value
                            .toString()
                            .padEnd(targetLength, "0");
                          return formattedValue.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            "."
                          );
                        }}
                      />
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-4 xl:gap-10 translate-x-2 sm:translate-x-4 xl:translate-x-20">
            {items.slice(2).map((i, index) => (
              <div
                key={index + 2}
                className={`min-w-[120px] flex gap-3 xl:gap-5 bg-[#1E1E1C] group hover:bg-[#F0D35A4D] transition-all duration-300 xl:py-[30px] py-3 px-[10px] xl:px-[25px] rounded-[4px] xl:rounded-[10px] `}
              >
                <img
                  src={i.icon}
                  alt={i.title}
                  className="sm:size-[60px] size-8 xl:size-[90%] aspect-square"
                />
                <div className="flex flex-col gap-1">
                  <p className="text-[#F0D35A99] group-hover:text-white text-[10px] xl:text-2xl whitespace-nowrap">
                    {i.title}
                  </p>
                  <p className="text-[#F0D35A] group-hover:text-white font-bold text-[13px] xl:text-[32px]">
                    {isVisible && (
                      <CountUp
                        end={Number(i.number)}
                        duration={3}
                        formattingFn={(value) => {
                          const targetLength = i.number.replace(
                            /[,.]/g,
                            ""
                          ).length;
                          const formattedValue = value
                            .toString()
                            .padEnd(targetLength, "0");
                          return formattedValue.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            "."
                          );
                        }}
                      />
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <img
            src={IMAGES.wave}
            alt=""
            className="absolute z-[-1] top-[-90%] left-[-10%] sm:left-unset sm:-top-2/3 hidden xl:block opacity-50"
          />
        </div>
        <div className="w-fit">
          <HeroBubble />
        </div>
      </div>
    </div>
  );
};

export default SectionNumber;
